import { useEffect } from 'react';
import { useApiPost } from '../../api/Api.hooks';
import { User } from '../../models/User';
import { log } from '../../tools/LogHelper';
import { stringify } from 'flatted';

export function useDeleteUser(id: number | undefined) {
  const { data, isLoading, error, post } = useApiPost<User>(
    `users/${id}/delete`
  );
  useEffect(
    () => void (error && log('Del Current User Error', stringify(error))),
    [error]
  );
  return {
    deletedUser: data,
    deletingUser: isLoading,
    deleteUserError: error,
    deleteUser: post
  };
}
